export default __webpack_public_path__ + "static/media/BILAL.bce0510e.png";